import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { PostClubProfileWorkConditionParams } from '@/shared/api/requests/club/working-condition/post/request';
import { postClubProfileWorkCondition } from '@/shared/api/requests/club/working-condition/post/request';

export const useClubProfileWorkConditionMutation = (
  settings?: MutationSettings<
    PostClubProfileWorkConditionParams,
    typeof postClubProfileWorkCondition
  >
) =>
  useMutation({
    mutationKey: ['ClubProfileWorkCondition'],
    mutationFn: ({ params, config }) =>
      postClubProfileWorkCondition({
        params,
        config
      }),
    ...settings?.options
  });
